export const ZAPUJCKA = 'Zapujcka';
